// extracted by mini-css-extract-plugin
module.exports = {"editor-container":"EditorContent_editor-container__1NQj1","bg-class":"EditorContent_bg-class__laQu7"};